import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

interface PrimaryButtonProps extends Omit<ButtonProps, 'variant' | 'color'> {
  loading?: boolean;
  variant?: 'contained' | 'outlined';
  color?: 'primary' | 'error' | 'warning' | 'info' | 'success';
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({ 
  children, 
  loading = false, 
  disabled = false,
  variant = 'contained',
  color = 'primary',
  startIcon,
  sx,
  ...props 
}) => {
  const buttonSx: SxProps<Theme> = {
    textTransform: 'none',
    fontWeight: 500,
    borderRadius: '4px',
    minHeight: '36px',
    px: 2,
    py: 1,
    '&:active': {
      transform: 'translateY(0)',
    },
    '&.Mui-disabled': {
      transform: 'none',
      boxShadow: 'none',
    },
    ...sx,
  };

  return (
    <Button
      variant={variant}
      color={color}
      disabled={disabled || loading}
      startIcon={
        loading ? (
          <CircularProgress size={16} color="inherit" />
        ) : (
          startIcon
        )
      }
      sx={buttonSx}
      {...props}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;